import { Routes } from '@angular/router';

import { GROUP_IDS } from '@demeter/lib/constants/group-ids';
import { roleGuard } from '@demeter/modules/auth';
import { AuthGuard } from '@demeter/modules/auth/auth.guard';

export const routes: Routes = [
	{
		path: '',
		children: [
			// Without this, '/' matches no child, so roleGuard's default denial redirect
			// (and the post-login landing) resolved to a blank page.
			{
				path: '',
				redirectTo: 'health',
				pathMatch: 'full'
			},
			{
				path: 'funds',
				loadChildren: () => import('@demeter/modules/funds').then(m => m.routes),
				canActivate: [roleGuard([GROUP_IDS.ADMIN])]
			},
			{
				path: 'transactions',
				loadChildren: () => import('@demeter/modules/transactions').then(m => m.routes),
				canActivate: [roleGuard([GROUP_IDS.ADMIN])]
			},
			// Bridges legacy /accounts/:id deep links. Note: for truly legacy PQK-shaped ids,
			// server-side resolution to a fundId is required (Core.API endpoint, not UI).
			{
				path: 'accounts/:id',
				redirectTo: 'funds/:id',
				pathMatch: 'full'
			},
			{
				path: 'accounts',
				redirectTo: 'funds',
				pathMatch: 'full'
			},
			{
				path: 'health',
				loadChildren: () => import('@demeter/modules/health').then(m => m.routes),
				canActivate: [AuthGuard]
			},
			{
				path: 'data',
				loadChildren: () => import('@demeter/modules/data').then(m => m.routes)
			},
			{
				path: 'reports',
				loadChildren: () => import('@demeter/modules/reports').then(m => m.routes),
				canActivate: [AuthGuard]
			},
			{
				path: 'report',
				redirectTo: 'reports'
			},
			{
				path: 'tools',
				loadChildren: () => import('@demeter/modules/tools').then(m => m.routes),
				canActivate: [AuthGuard]
			},
			// Example: Route protected by role guard
			// Uncomment and customize based on your needs:
			// {
			// 	path: 'admin',
			// 	loadChildren: () => import('@demeter/modules/admin').then(m => m.routes),
			// 	canActivate: [AuthGuard, roleGuard(['Admin', 'SuperAdmin'])]
			// },
			// {
			// 	path: 'super-admin',
			// 	loadChildren: () => import('@demeter/modules/super-admin').then(m => m.routes),
			// 	canActivate: [AuthGuard, roleGuard(['SuperAdmin'], { requireAll: false })]
			// },
			{
				path: 'price-history',
				redirectTo: 'tools'
			}
		]
	}
];
